import { getProactiveDraftsStore } from "../store/store";

export function getProactiveDraftAddedOnEditor(itemId: string | undefined, editorId: string): boolean {
    if (itemId) {
        const proactiveDrafts = getProactiveDraftsStore().proactiveDraftsListMap.get(itemId);
        if (proactiveDrafts) {
            return proactiveDrafts.proactiveDraftsAddedOnEditorList.includes(editorId);
        }
    }
    return false;
}
